import { useEffect } from 'react';

import { useSocialInboxNavigation } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxNavigation';
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import { INSTAGRAM } from '@/lib/socialProfile';
import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

/**
 * Hook to navigate from MENTIONS/DM to comments tab when:
 * 1. The selected profile is not Instagram
 * 2. Or any group is selected
 */
export const useNavigateToComments = () => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const { activeGroup } = useActiveGroup();
    const { currentSocialInbox, navigateTo } = useSocialInboxNavigation();

    useEffect(() => {
        // Check if we need to navigate from mentions to comments
        const isMentionsTab = currentSocialInbox === SOCIAL_INBOX_META.mention.key;
        const isDMTab = currentSocialInbox === SOCIAL_INBOX_META.dm.key;
        const isNonInstagramProfile = activeSocialProfile?.social_network_type !== INSTAGRAM;
        const isGroup = !activeSocialProfile && activeGroup !== null;

        if ((isMentionsTab || isDMTab) && (isNonInstagramProfile || isGroup)) {
            navigateTo(SOCIAL_INBOX_META.comment.key);
        }
    }, [activeSocialProfile, activeGroup, currentSocialInbox, navigateTo]);
};
